export const Signal = {
  Next: 'Next',
  Previous: 'Previous',
  ExitToSignIn: 'ExitToSignIn',
};
